import { render, staticRenderFns } from "./SemestersSelectbox.vue?vue&type=template&id=1ebf4893"
import script from "./SemestersSelectbox.vue?vue&type=script&lang=js"
export * from "./SemestersSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports